import React, {useState, useEffect} from 'react'
import firebase from '../../firebase/config'
import CuentaMonedaNacional from '../../components/CuentaMonedaNacional'
import CuentaMonedaInternacional from '../../components/CuentaMonedaInternacional'
import {Link} from 'react-router-dom';
import moment from 'moment';
import SearchList from '../../components/SearchList';
import OtherAccount from '../../components/OtherAccount';

function DataBank() {

    const paises = [ "Afganistán",
    "Albania",
    "Alemania",
    "Andorra",
    "Angola",
    "Antigua y Barbuda",
    "Arabia Saudita",
    "Argelia",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaiyán",
    "Bahamas",
    "Bahrein",
    "Bangladesh",
    "Barbados",
    "Belarús",
    "Belice",
    "Benin",
    "Bhután",
    "Bolivia",
    "Bosnia y Herzegovina",
    "Botswana",
    "Brasil",
    "Brunei Darussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Bélgica",
    "Cabo Verde",
    "Camboya",
    "Camerún",
    "Canadá",
    "Chad",
    "Chequia",
    "Chile",
    "China",
    "Chipre",
    "Colombia",
    "Comoras",
    "Congo",
    "Costa Rica",
    "Croacia",
    "Cuba",
    "Dinamarca",
    "Djibouti",
    "Dominica",
    "Ecuador",
    "Egipto",
    "El Salvador",
    "Emiratos Árabes Unidos",
    "Eritrea",
    "Eslovaquia",
    "Eslovenia",
    "España",
    "Estados Unidos de América",
    "Estonia",
    "Eswatini",
    "Etiopía",
    "Federación de Rusia",
    "Fiji",
    "Filipinas",
    "Finlandia",
    "Francia",
    "Gabón",
    "Gambia",
    "Georgia",
    "Ghana",
    "Granada",
    "Grecia",
    "Guatemala",
    "Guinea",
    "Guinea Ecuatorial",
    "Guyana",
    "Haití",
    "Honduras",
    "Hungría",
    "India",
    "Indonesia",
    "Iraq",
    "Irlanda",
    "Irán",
    "Islandia",
    "Islas Cook",
    "Islas Feroe",
    "Islas Marshall",
    "Islas Salomón",
    "Israel",
    "Italia",
    "Jamaica",
    "Japón",
    "Jordania",
    "Kazajstán",
    "Kenya",
    "Kirguistán",
    "Kiribati",
    "Kuwait",
    "Lesotho",
    "Letonia",
    "Liberia",
    "Libia",
    "Lituania",
    "Luxemburgo",
    "Líbano",
    "Macedonia del Norte",
    "Madagascar",
    "Malasia",
    "Malawi",
    "Maldivas",
    "Malta",
    "Malí",
    "Marruecos",
    "Mauricio",
    "Mauritania",
    "Micronesia",
    "Mongolia",
    "Montenegro",
    "Mozambique",
    "Myanmar",
    "México",
    "Mónaco",
    "Namibia",
    "Nauru",
    "Nepal",
    "Nicaragua",
    "Nigeria",
    "Noruega",
    "Nueva Zelandia",
    "Níger",
    "Omán",
    "Pakistán",
    "Palau",
    "Panamá",
    "Paraguay",
    "Países Bajos",
    "Perú",
    "Polonia",
    "Portugal",
    "Qatar",
    "Reino Unido de Gran Bretaña e Irlanda del Norte",
    "República Centroafricana",
    "República Democrática Popular Lao",
    "República Democrática del Congo",
    "República Dominicana",
    "República Popular Democrática de Corea",
    "República Unida de Tanzanía",
    "República de Corea",
    "República de Moldova",
    "República Árabe Siria",
    "Rumania",
    "Samoa",
    "San Marino",
    "San Vicente y las Granadinas",
    "Santa Lucía",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leona",
    "Singapur",
    "Somalia",
    "Sudáfrica",
    "Sudán",
    "Suecia",
    "Suiza",
    "Suriname",
    "Tailandia",
    "Tayikistán",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad",
    "Turkmenistán",
    "Turquía",
    "Tuvalu",
    "Túnez",
    "Ucrania",
    "Uganda",
    "Uruguay",
    "Uzbekistán",
    "Vanuatu",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe" ]

    const [btnMessage, setBtnMessage] = useState("Guardar datos bancarios");
    const [user, setUser] = useState({})
    // const [dataBank, setDataBank] = useState({})
    const [bancos, setBancos] = useState([])
    const [accountNational, setAccountNational] = useState(true)
    const [accountInternational, setAccountInternational] = useState(false)
    const [accountOther, setAccountOther] = useState(false)
    const tipoCuentas = ["Ahorro", "Corriente"]
    
    const [bankInfo, setBankInfo] = useState({
      banco: "",
      tipoCuenta: "",
      numeroCuenta: "",
      beneficiario: "",
    })


    const [bancosSearched, setBancosSearched] = useState([])

    const [banco, setBanco] = useState("")
    const [numeroMovil, setNumeroMovil] = useState("")
    const [dataBank, setDataBank] = useState({
        nombreTitular: "",
        rif: "",
        nroCuenta: "",
        tipoCuenta: "",
        email: "",
        codigoInterbancario: "",
    })

    async function getBankData(id){
        try{
            let d = {
                banco: "",
                tipoCuenta: "",
                numeroCuenta: "",
                beneficiario: "",
            }
            await firebase.db.collection("Aliados").doc(id).collection("Datos Bancarios").get().then((val)=>{
                setDataBank(val.docs[0] !== undefined ? val.docs[0].data() : d)
            })
        }catch(e){
            console.log("Error: " + e)
        }
    }

    async function fetchData(pais) {
        try{
            await firebase.db.collection("Bancos").doc(pais).get().then((val)=>{
                setBancos(val !== undefined ? val.data().tipos : ["Cargando"])
            })
        }catch(e){
            console.log("Error: " + e)
        }
    }
    
    useEffect(() => {
        firebase.getCurrentUser().then((val)=>{
            setUser(val)
            fetchData(val.pais)
            getBankData(val.aliadoId)
            
        })
    })

    return (

        <div className="main-content-container container-fluid px-4">

            <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
              <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                <div className="row align-items-center">
                    <div className="ml-2 col row">
                        <p className="page-title bold"><Link className="page-title light ml-3" to="/profile">Mi cuenta</Link><span>Datos Bancarios</span><Link className="page-title light ml-3" to="/petpoints">Pet Points</Link></p>
                    </div>
                </div>
              </div>
              <div className="col-12 col-sm-1 mb-0">
                <div className="row align-items-center justify-content-space-around">
                  <i className="material-icons color-white display-5">help_outline</i>
                </div>
              </div>
            </div>
            <div className="row no-gutters container">
                <div className="col-lg-7 mb-5">
                    { accountNational && <CuentaMonedaNacional bankList={bancos}/> }
                    { accountInternational && <CuentaMonedaInternacional bankList={bancos}/> }
                    { accountOther && <OtherAccount countries={paises}/> }
                </div>
                <div className="col-lg-5">
                    <div className="data-bank-container">
                        <h3 className="mb-2">Cuentas bancarias</h3>
                        <div className="share-img-container">
                          <img src="../images/icons/credit-card.svg" alt=""/>
                        </div>
                        <p className="color-primary light">Agrega las cuentas bancarias donde Priority Pet va a hacer los depositos de tus ventas</p>
                        <div className="data-bank-column">
                            <div onClick={()=>{
                                setAccountNational(true); setAccountInternational(false); setAccountOther(false)
                            }} className={`cursor-pointer data-bank-account-select-btn ${accountNational && "active"}`}>
                                Cuenta moneda nacional
                            </div>
                            <div onClick={()=>{
                                setAccountNational(false); setAccountInternational(true); setAccountOther(false)
                            }} className={`cursor-pointer data-bank-account-select-btn ${accountInternational && "active"}`}>
                                Cuenta moneda internacional
                            </div>
                            <div onClick={()=>{
                                setAccountNational(false); setAccountInternational(false); setAccountOther(true)
                            }} className={`cursor-pointer data-bank-account-select-btn ${accountOther && "active"}`}>
                            Otra cuenta
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>

          </div>
    )

}

export default DataBank
